<script setup lang="ts">
import { computed } from "vue";
import { n } from "components/jiffy/vue-cart/helpers/currency";
import { type Standard } from "../../types";

const props = defineProps<{
  artwork: Standard.Artwork;
}>();

const isLoading = computed(() => !Number(props.artwork.pricing?.enhancementTierRetailPrice));

const oldPrice = computed(() =>
  isLoading.value ? 0 : n(props.artwork.pricing.enhancementTierRetailPrice, "currency")
);
const newPrice = computed(() =>
  isLoading.value ? 0 : n(props.artwork.pricing.enhancementTierPrice, "currency")
);
</script>

<template>
  <span :class="[$attrs['class'], 'price-label', { 'price-label--loading': isLoading }]">
    <span class="price-label__prices">
      <span class="price-label__new-price">{{ newPrice }}</span>
      {{ " " }}
      <span class="price-label__old-price">{{ oldPrice }}</span>
    </span>
    <span class="price-label__info">Per Design Size</span>
  </span>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings";
@import "frontend/init/jiffy/mixin";
@import "../ArtworkQualityConfigPanel.scss";

.price-label {
  display: flex;
  flex-direction: column;
  line-height: 1;
  flex-shrink: 0;
  gap: 4px;
  position: absolute;
  right: 16px;

  &--loading {
    visibility: hidden;
  }

  &__prices {
    display: inline;
  }

  &__new-price {
    color: $price-product-card;
    font-family: Arial;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;

    @include with-quality-container {
      font-size: 24px;
    }
  }

  &__old-price {
    color: $silver-chalice;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    text-decoration-line: line-through;

    @include with-quality-container {
      font-size: 16px;
    }
  }

  &__info {
    color: $deep-gray;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;

    @include with-quality-container {
      font-size: 16px;
    }
  }
}
</style>
